import { useEffect } from 'react';
import { useAgentFindingsStore } from '../../../stores/prioritization/agentFindingsStore';
import { getCurrentWorkspaceId } from '../../../lib/supabaseSync';
import type { AgentFinding } from '../../../lib/agentFindingsService';

const EMPTY: AgentFinding[] = [];

/** Every finding this agent raised that still waits for a person. */
export function useOpenFindings(agentType: string): AgentFinding[] {
  const active = useAgentFindingsStore((s) => s.byAgent[agentType]?.active ?? EMPTY);
  const fetchActive = useAgentFindingsStore((s) => s.fetchActive);
  const workspaceId = getCurrentWorkspaceId();
  useEffect(() => {
    if (workspaceId) void fetchActive(workspaceId, agentType);
  }, [workspaceId, agentType, fetchActive]);
  return active;
}
